import { IApiUser, IUserName } from './types';
import { capitalizeFirstLetter } from 'src/helpers/capitalizeFirstLetter';

export class User implements IUserName {
  public readonly email: string;
  public readonly name: string | null;
  public readonly lastName: string | null;
  public readonly color: string | null;
  public readonly enabled: boolean;
  public readonly userName: string;

  constructor(apiUser: IApiUser) {
    this.email = apiUser.email;
    this.name = apiUser.name;
    this.lastName = apiUser.lastName;
    this.color = apiUser.color;
    this.enabled = !!apiUser.enabled;
    this.userName = this.toUserName(apiUser);
  }

  private toUserName(user: IApiUser): string {
    const { email, name, lastName } = user;
    return !name && !lastName
      ? email
      : `${name ? capitalizeFirstLetter(name) : ''} ${lastName ? capitalizeFirstLetter(lastName) : ''}`;
  }
}
